import { render, staticRenderFns } from "./ProjectPublished.vue?vue&type=template&id=010a0aec&scoped=true&"
import script from "./ProjectPublished.vue?vue&type=script&lang=ts&"
export * from "./ProjectPublished.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a0aec",
  null
  
)

export default component.exports